import React from 'react'
import _isEmpty from 'lodash/isEmpty'
import SortableTable from '../../_library/SortableTable'
import EmptyBar from '../../_library/EmptyBar'

const ScheduledEmails = ({ columns, data = [], actions = [] }) => {
  if (_isEmpty(data)) {
    return <EmptyBar />
  }

  return <SortableTable data={data} tableColumns={columns} actions={actions} />
}

export { ScheduledEmails }
